// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  kind: __t.u8(),
  rulesetVersion: __t.u32().name("ruleset_version"),
  seed: __t.byteArray(),
  briefHash: __t.byteArray().name("brief_hash"),
  blob: __t.byteArray(),
  blobHash: __t.byteArray().name("blob_hash"),
  certificate: __t.byteArray(),
  voiceFilled: __t.bool().name("voice_filled"),
  jobId: __t.u64().name("job_id"),
  frozenAt: __t.timestamp().name("frozen_at"),
});
